import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-personal",
  "use": "icon-personal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-personal\"><path d=\"M512 0A512 512 0 1 1 0 512 512 512 0 0 1 512 0zM205.97223 686.927031a382.903397 382.903397 0 0 0 314.233383 183.510783 382.676514 382.676514 0 0 0 314.157755-183.510783 460.913442 460.913442 0 0 0-628.391138 0z m305.989956-226.013589a153.6 153.6 0 1 0-153.562186-153.6 153.6 153.6 0 0 0 153.6 153.6z\" fill=\"#474CCE\" p-id=\"2777\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol